import React from 'react';
import { CustomAccordion } from 'components/Ui/styled';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NotesHistory from './NotesHistory';

const AssetNotes = (props) => {
  const { notesData, heading = 'Notes' } = props;
  return (
    <>
      <CustomAccordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography variant="h6">{heading}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <NotesHistory notesData={notesData} />
        </AccordionDetails>
      </CustomAccordion>
    </>
  );
};

export default AssetNotes;
